export default __webpack_public_path__ + "static/media/FXComplete.bc1c39fb.png";